<!-- Sidebar -->
<app-sidebar></app-sidebar>
<div>
    <app-header></app-header>
    <!-- Page Content -->
    <div id="content">
        <div style="padding-right: 15px;">
            <app-home></app-home>
        </div> 
    </div>
    <app-footer></app-footer>
</div>